"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingDropdownWrap = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var MenuItem_1 = tslib_1.__importDefault(require("@material-ui/core/MenuItem"));
var FormControl_1 = tslib_1.__importDefault(require("@material-ui/core/FormControl"));
var Select_1 = tslib_1.__importDefault(require("@material-ui/core/Select"));
var InputBase_1 = tslib_1.__importDefault(require("@material-ui/core/InputBase"));
var BootstrapInput = styles_1.withStyles(function (theme) {
    return styles_1.createStyles({
        input: {
            borderRadius: 3,
            position: "relative",
            backgroundColor: theme ? theme.app.Setting.color13 : "",
            border: "1px solid rgb(32,34,37)",
            fontSize: 16,
            padding: "10px 26px 10px 12px",
            fontFamily: [
                "-apple-system",
                "BlinkMacSystemFont",
                '"Segoe UI"',
                "Roboto",
                '"Helvetica Neue"',
                "Arial",
                "sans-serif",
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
            ].join(","),
            "&:focus": {
                borderRadius: 3,
                borderColor: "rgb(32,34,37)",
            },
        },
    });
})(InputBase_1.default);
var useStyles = styles_1.makeStyles(function (theme) { return ({
    formControl: {
        minWidth: "100%",
        padding: 0,
    },
    item: {
        color: theme ? theme.app.Setting.color12 : "",
    },
}); });
function SettingDropdownWrap(props) {
    var data = props.data, onChange = props.onChange;
    var classes = useStyles();
    var _a = tslib_1.__read(react_1.default.useState(""), 2), age = _a[0], setAge = _a[1];
    var _b = tslib_1.__read(react_1.default.useState(false), 2), open = _b[0], setOpen = _b[1];
    var handleChange = function (event) {
        setAge(event.target.value);
        onChange(data[event.target.value / 10]);
    };
    var handleClose = function () {
        setOpen(false);
    };
    var handleOpen = function () {
        setOpen(true);
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(FormControl_1.default, { className: classes.formControl },
            react_1.default.createElement(Select_1.default, { labelId: "demo-controlled-open-select-label", id: "demo-controlled-open-select", open: open, onClose: handleClose, onOpen: handleOpen, value: age, onChange: handleChange, input: react_1.default.createElement(BootstrapInput, null) }, data.map(function (item, index) { return (react_1.default.createElement(MenuItem_1.default, { value: index * 10, key: index, className: classes.item }, item)); })))));
}
exports.SettingDropdownWrap = SettingDropdownWrap;
//# sourceMappingURL=SettingDropdownWrap.js.map